import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'unit-two-lesson-one-guide',
    templateUrl: './_guide.component.html',
    styleUrls: ['../../_shared/lesson-guides/lesson-guide.component.css']
})
export class UnitTwoLessonOneGuideComponent {

    pageTitle: string = "Lesson Guide | Unit 2, Lesson 1 | T-Folio";
    title: string = "Lesson Guide";
    subtitle: string = "Lesson 1: How to Set Goals";

    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
}
